import React from "react";
import "../components.css";


export default function OverlaySelection ( { label = "Label", width = "25vw", height = "25vh", backgroundColor = "red", buttonColor = "red", choices = [[[1, 1], [1, 1], [1, 1]], [[1, 1], [1, 1], [1, 1]]], result = [], onChange = () => {console.log("No function given")}, defaultState = "" }: {label: string, width: string, height: string, backgroundColor: string, buttonColor: string, choices: any, result?: any, onChange: Function, defaultState?: string}) {
    const [overlay, setOverlay] = React.useState(false);
    const [state, setTileState] = React.useState(defaultState);

    if (result.length === 0) {
        result = choices;
    }
    const tileStyle = {
        width: width,
        height: height,
    }

    function onClick(col: string) {
        onChange(col);
        setOverlay(false);
        setTileState(col);
    }

    return (
        <div className="tile" style={tileStyle}>
            {overlay && (
                <div className="overlay">
                    {choices.map((row: [[any]], rowIndex: number) => (
                        <div key={rowIndex} className="overlayRow">
                            {typeof(row) !== "string" ? row.map((col, colIndex: number) => (
                                <div className="overlayTile">
                                    <div key={colIndex} onClick={() => {onClick(choices[rowIndex][colIndex])}} style={Object.assign({}, {backgroundColor: buttonColor})}>
                                        <h1>{col}</h1>
                                    </div>
                                </div>
                            )):
                            <div className="overlayTile">
                                <div onClick={() => {onClick(row)}} style={Object.assign({}, {backgroundColor: buttonColor})}>
                                    <h1>{row}</h1>
                                </div>
                            </div> 
                            }
                        </div>
                    ))}
                </div>
            )}
            <div id="tileOverlay" onClick={() => setOverlay(true)} style={Object.assign({}, {backgroundColor: backgroundColor})}>
                <h1>{label}</h1>
                <p>{state}</p>
            </div>
        </div>
    )
}